import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	breadcrumb: {
		display: "flex",
		alignItems: "center"
	},
	logoImg: {
		maxHeight: 70
	},
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	explanationLink: {
		cursor: "pointer"
	},
	explanationText: {
		color: colors.gray[500]
	},
	categoryTitle: {
		color: colors.gray[500]
	},
	disableTab: {
		color: colors.gray[400],
		boxShadow: "none",
		opacity: 0.7
	},
	tabArea: {
		display: "flex",
		gap: 12
	},
	infoIcon: {
		width: 16,
		height: 16
	}
})

export default useStyles
